import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-491f796d")

_pushScopeId("data-v-491f796d")
const _hoisted_1 = { class: "health" }
const _hoisted_2 = { class: "person clearfix" }
const _hoisted_3 = { class: "member fl" }
const _hoisted_4 = { class: "img fl" }
const _hoisted_5 = { class: "info fl" }
const _hoisted_6 = { style: {"float":"left"} }
const _hoisted_7 = { class: "name fl" }
const _hoisted_8 = { style: {"float":"left","clear":"both"} }
const _hoisted_9 = { style: {"position":"relative","top":"-3px"} }
const _hoisted_10 = { class: "age fl" }
const _hoisted_11 = { class: "fr btnbox" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "btntxt" }, "绑定设备", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "btntxt" }, "设备设置", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "btntxt" }, "切换成员", -1)
const _hoisted_15 = {
  key: 0,
  class: "bindtip card-universal"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "tbox clearfix" }, [
  /*#__PURE__*/_createVNode("div", { class: "t fl" }, "您还未绑定任何手表"),
  /*#__PURE__*/_createVNode("div", { class: "i fl" }, "（在手表设备上操作）")
], -1)
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"bindtxtbox clearfix\" data-v-491f796d><div class=\"bindtxti fl\" data-v-491f796d>点击手表</div><div class=\"bindtxti fl\" data-v-491f796d>打开设备</div><div class=\"bindtxti fl\" data-v-491f796d>扫描绑定码</div><div class=\"bindtxti fl\" data-v-491f796d>绑定成功</div></div>", 1)
const _hoisted_18 = { class: "health-report card-universal" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "tbox clearfix" }, [
  /*#__PURE__*/_createVNode("div", { class: "t fl" }, "健康报告")
], -1)
const _hoisted_20 = { class: "health-report-cont clearfix" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "txt" }, "测评报告", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "txt" }, "趋势统计报告", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("专属睡眠改善方案")
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "tabbar-position" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_tag = _resolveComponent("van-tag")
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_WatchUse = _resolveComponent("WatchUse")
  const _component_TodayHeartRate = _resolveComponent("TodayHeartRate")
  const _component_van_col = _resolveComponent("van-col")
  const _component_van_row = _resolveComponent("van-row")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")

  return (_openBlock(), _createBlock(_component_van_pull_refresh, {
    modelValue: _ctx.loading,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.loading = $event)),
    onRefresh: _ctx.onRefresh
  }, {
    default: _withId(() => [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_van_image, {
                  round: "",
                  fit: "cover",
                  class: "avatar__wrapper",
                  src: _ctx.userInfo?.avatarUrl || _ctx.defaultAvatar,
                  onClick: _ctx.toMemberInfo
                }, null, 8, ["src", "onClick"])
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, _toDisplayString(_ctx.userInfo.userName), 1),
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode(_component_van_tag, {
                        round: "",
                        color: "#efefef",
                        "text-color": "rgb(159, 102, 204)",
                        "data-clipboard-text": _ctx.userInfo.uid,
                        ref: "copyContent_UID",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.copyContent(_ctx.$refs.copyContent_UID.$el,$event)), ["stop"]))
                      }, {
                        default: _withId(() => [
                          _createTextVNode("UID： " + _toDisplayString(_ctx.userInfo.uid), 1)
                        ]),
                        _: 1
                      }, 8, ["data-clipboard-text"])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_10, [
                  (_ctx.userInfo?.sex != '女')
                    ? (_openBlock(), _createBlock(_component_van_image, {
                        key: 0,
                        src: require('@/assets/img/health/female.png'),
                        class: "sexicon"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_van_image, {
                        key: 1,
                        src: require('@/assets/img/health/male.png'),
                        class: "sexicon"
                      }, null, 8, ["src"]))
                ])
              ]),
              _createVNode("div", {
                class: "edit fl",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toMemberInfo && _ctx.toMemberInfo(...args)))
              }, [
                _createVNode(_component_van_icon, { name: "edit" })
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              (!_ctx.wearingState)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: "fl btnitem",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.scan && _ctx.scan(...args)))
                  }, [
                    _createVNode(_component_van_image, {
                      src: require('@/assets/img/health/bind.png'),
                      class: "btnimg"
                    }, null, 8, ["src"]),
                    _hoisted_12
                  ]))
                : (_openBlock(), _createBlock("div", {
                    key: 1,
                    class: "fl btnitem",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.equipmentSet && _ctx.equipmentSet(...args)))
                  }, [
                    _createVNode(_component_van_image, {
                      src: require('@/assets/img/health/设备设置@2x.png'),
                      class: "btnimg"
                    }, null, 8, ["src"]),
                    _hoisted_13
                  ])),
              _createVNode("div", {
                class: "fl btnitem member",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.switchMembers && _ctx.switchMembers(...args)))
              }, [
                _createVNode(_component_van_image, {
                  src: require('@/assets/img/health/切换成员@2x.png'),
                  class: "btnimg"
                }, null, 8, ["src"]),
                _hoisted_14
              ])
            ])
          ]),
          (!_ctx.wearingState)
            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_van_image, {
                  src: require('@/assets/img/health/bindStep.png'),
                  class: "bindstep"
                }, null, 8, ["src"]),
                _hoisted_17,
                _createVNode(_component_van_image, {
                  src: require('@/assets/img/health/bindButton.png'),
                  class: "bindbtn",
                  onClick: _ctx.scan
                }, null, 8, ["src", "onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.wearingState)
            ? (_openBlock(), _createBlock(_component_WatchUse, {
                key: 1,
                "member-id": _ctx.userInfo.memberId
              }, null, 8, ["member-id"]))
            : _createCommentVNode("", true),
          (_ctx.wearingState)
            ? (_openBlock(), _createBlock(_component_TodayHeartRate, { key: 2 }))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode("div", _hoisted_20, [
              _createVNode("div", {
                class: "health-report-cont-item fl mr",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goToReportList && _ctx.goToReportList(...args))),
                style: {'backgroundImage': `url(${require('@/assets/img/icon/测评报告.png')})`}
              }, [
                _hoisted_21
              ], 4),
              _createVNode("div", {
                class: "health-report-cont-item fl",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goToTrend && _ctx.goToTrend(...args))),
                style: {'backgroundImage': `url(${require('@/assets/img/icon/趋势统计报告.png')})`}
              }, [
                _hoisted_22
              ], 4)
            ])
          ]),
          _createVNode(_component_van_row, { style: {"margin-top":"15px","position":"sticky","bottom":"0"} }, {
            default: _withId(() => [
              _createVNode(_component_van_col, {
                span: "20",
                offset: "2"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_van_row, null, {
            default: _withId(() => [
              _createVNode(_component_van_col, {
                span: "20",
                offset: "2"
              }, {
                default: _withId(() => [
                  _createVNode(_component_van_button, {
                    "loading-size": "25px",
                    icon: _ctx.leafImg,
                    onClick: _ctx.toSleepScheme,
                    type: "primary",
                    color: "rgb(159, 102, 204)",
                    size: "normal",
                    block: ""
                  }, {
                    default: _withId(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  }, 8, ["icon", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_24
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onRefresh"]))
})